export const actionTypes = {
  AGENT_CHANGED: 'agent_changed',
  DRIVER_ARRIVAL_GEOFENCE_TRIGGERED: 'driver_arrival_geofence_triggered',
  UPDATE_AGENT: 'update_agent',
  UPDATE_ORDER: 'update_order',
  UPDATE_ETA: 'update_eta',
  FETCH_REQUEST: 'fetch_request',
  FETCH_REQUEST_INTERNAL: 'fetch_request_internal',
  FETCH_SUCCESS: 'fetch_success',
  FETCH_FEEDBACK_REQUEST: 'fetch_feedback_request',
  FETCH_FEEDBACK_SUCCESS: 'fetch_feedback_success',
  FETCH_FAIL: 'fetch_fail',
  DEMO_MODE: 'demo_mode',
  THEME_REQUEST: 'theme_request',
  THEME_LOADED: 'theme_loaded',
  THEME_UPDATED: 'theme_updated',
  SET_LIVE_ETA: 'set_live_eta',
  HYDRATE: 'HYDRATE',
}

export const themeRequest = ({ orderId, baseUrl }) => {
  return {
    type: actionTypes.THEME_REQUEST,
    orderId,
    baseUrl,
  }
}

export const themeLoaded = () => {
  return {
    type: actionTypes.THEME_LOADED,
  }
}

export const themeUpdated = (theme) => {
  return {
    type: actionTypes.THEME_UPDATED,
    payload: theme,
  }
}

export const fetchRequest = ({ orderId, baseUrl }) => {
  return {
    type: actionTypes.FETCH_REQUEST,
    orderId,
    baseUrl,
  }
}

export const fetchSuccess = (payload) => {
  return {
    type: actionTypes.FETCH_SUCCESS,
    payload,
  }
}

export const fetchInternal = ({
  accountId,
  partnersOrderId,
  baseUrl,
  orderId,
}) => {
  return {
    type: actionTypes.FETCH_REQUEST_INTERNAL,
    payload: {
      account_uuid: accountId,
      partners_unique_internal_order_id: partnersOrderId,
    },
    orderId,
    baseUrl,
  }
}

export const fetchFeedback = ({ orderId, baseUrl }) => {
  return {
    type: actionTypes.FETCH_FEEDBACK_REQUEST,
    orderId,
    baseUrl,
  }
}

export const fetchFeedbackSuccess = (payload) => {
  return {
    type: actionTypes.FETCH_FEEDBACK_SUCCESS,
    payload,
  }
}

export const updateAgent = (location) => {
  return {
    type: actionTypes.UPDATE_AGENT,
    payload: location,
  }
}

export const updateOrder = (status) => {
  return {
    type: actionTypes.UPDATE_ORDER,
    payload: status,
  }
}

export const updateEta = (time) => {
  return {
    type: actionTypes.UPDATE_ETA,
    payload: time,
  }
}

export const agentChanged = (agent) => {
  return {
    type: actionTypes.AGENT_CHANGED,
    payload: agent,
  }
}

export const driverArrivalGeofenceTriggered = () => {
  return {
    type: actionTypes.DRIVER_ARRIVAL_GEOFENCE_TRIGGERED,
  }
}

export const demoMode = (page) => {
  return {
    type: actionTypes.DEMO_MODE,
    payload: page,
  }
}
